import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "form-error",
  "use": "form-error-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"form-error\"><g fill=\"#EC1A1A\" fill-rule=\"nonzero\"><path d=\"M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20zm0-2c-9.941 0-18-8.059-18-18S10.059 2 20 2s18 8.059 18 18-8.059 18-18 18z\" /><path d=\"M14.057 26.695l12.638-12.638-1.415-1.414L12.643 25.28z\" /><path d=\"M25.28 26.695L12.643 14.057l1.414-1.414L26.695 25.28z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol